import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuthContext } from 'services/authentication/AuthenticationContext';
import InlineForm from 'components/forms/InlineForm';
import { FieldType } from 'types/FieldTypes';
import { FormButtonType } from 'types/ButtonTypes';
import { v4 as uuidv4 } from 'uuid';

const TwoFactorForm: React.FC = () => {
    const { handleTwoFactorVerify } = useAuthContext();
    const history = useHistory();
    const viewKey = useMemo(() => uuidv4(), []);

    const formDescription = 'account.two_factor_header_description'

    // Handles the submit of the two factor code in a custom api function
    const verifyTwoFactorCode = async (submitData: Record<string, any>) => {
        const code = submitData['twofactor-code'];

        // Verify the code and complete the login
        await handleTwoFactorVerify(code);

        // Redirect to the root so the router follows the login redirect
        history.push('/');
    }

    const fields: FieldType[] = [
        {
            type: 'text',
            name: 'twofactor-code',
            placeholder: 'account.two_factor_placeholder',
        },
    ];

    const buttons: FormButtonType[] = [
        {
            label: 'account.login_button_label',
            position: 'fullwidth',
            hierarchy: 'primary',
            onClick: 'handleSubmit',
            size: 'large',
            showLoader: true,
        },
    ];

    return (
        <InlineForm
            viewKey={viewKey}
            customApiFunction={verifyTwoFactorCode}
            formDescription={formDescription}
            fields={fields}
            buttons={buttons}
        />
    );
};

export default TwoFactorForm;
